import { useEffect } from "react";
import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
  :root {
    --red: #e52e4d;
    --white: #FFF;
    --black: #2F2F2F;
    --black-2:#1E1E1E;
    --alphaBlack: #000000;
    --black-2:#1E1E1E;
    --black-3:#353535;

    --yellow-400:#FFD789;
    --yellow-500: #F6C76B;
    --gray-40:#F0F0F0;
    --gray-45:#767676;
    --gray-50: #686A69;
    --gray-60: #8F8F8F;
    --gray-100: #B6B6B6;
    --gray-150: #B9B9B9;
    --gray-200: #D2D2D2;
    --gray-300: #EBEBEB;
    --gray-400: #ECECEC;
    --gray-500: #F4F4F4;
    --gray-550:#6F6F6F;
    --gray-600:#686868;
    --gray-700: #535353;
    --gray-800:#9D9D9D;
    --shadow-500: 0px 4px 8px rgba(91, 91, 91, 0.2);
    --green:#57C06E;
    --green-2:#2DCE68;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    scroll-behavior: smooth;

    @media (max-width: 1080px) {
      font-size: 93.75%;
    }
    @media (max-width: 720px) {
      font-size: 87.5%;
    }
  }

  body {
    background: var(--white);
    -webkit-font-smoothing: antialiased;
  }

  body, input, textarea, select, button {
    font-family: "Montserrat", sans-serif;
    font-weight: 400;
  } 

  h1, h2, h3, h4, h5, h6, strong {
    font-weight: 600;
  }

  button {
    cursor: pointer;
  }

  [disabled] {
    opacity: 0.6;
    cursor: not-allowed;
  }

  .hidden {
    overflow: hidden;
  }

  ::-webkit-scrollbar {
    -webkit-appearance: none;
    background: var(--gray-500);
    width: 6px;
    height: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: var(--gray-50);
  }

  .aligncenter {
    text-align: center;
  }

  .width-190px {
    width:190px;
  }

  .hidden-content {
    display:none !important;
  }

  .global-margin-bottom {
    margin-bottom:20px;
  }

  .background-light-gray {
    background:#F4F4F4;
  }

  .full-width-and-height {
    height:100%;
    width:100%;
  }

  .flex-direction-column {
    flex-direction:column;
  }

  .bold {
    font-weight:700;
  }

  .margin-center-x {
    margin:0 auto;
  }

  .border-none {
    border:none;
  }

  .text-center {
    text-align:center;
  }

  .relative {
    position:relative;
  }
`;

const FontLoader: React.FC = () => {
  useEffect(() => {
    const link = document.createElement("link");
    link.href =
      "https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap";
    link.rel = "stylesheet";
    document.head.appendChild(link);
  }, []);

  return null;
};

export default FontLoader;
